import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import { get, set, orderBy } from 'lodash'
import moment from '../../lib/moment.js'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import { Button, Container, Row, Col, Modal } from 'reactstrap'
import {
  modalAction,
  authAction,
  publicHolidayAction,
  employeeAction,
} from './../../actions/'
import {
  modalSelector,
  authSelector,
  publicHolidaySelector,
  employeeSelector,
} from './../../selectors'
import { checkModifiedBy, searchPublicHoliday } from '../../function'
import CustomModalMessage from '../../components/modal-message'
import Searchbar from '../../components/searchbar'
import withLayout from '../../helpers/withLayout'
import PublicHolidayForm from '../../components/public-holiday'
import PublicHolidayTable from '../../components/table-public-holiday'

class HolidayMasterPage extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (get(nextProps, 'getPublicHolidayData.length') !== 0) {
      set(tempState, 'publicHoliday', nextProps.getPublicHolidayData)
      set(tempState, 'defaultPublicHoliday', nextProps.getPublicHolidayData)
      nextProps.resetGetPublicHoliday()
    }
    if (nextProps.getPublicHolidayByIDData) {
      set(tempState, 'description', get(nextProps, 'getPublicHolidayByIDData.description'))
      set(tempState, 'date', get(nextProps, 'getPublicHolidayByIDData.date'))
      set(tempState, 'is_active', get(nextProps, 'getPublicHolidayByIDData.is_active'))
      set(tempState, 'updated', get(nextProps, 'getPublicHolidayByIDData.updated'))
      set(tempState, 'updated_by', checkModifiedBy(get(nextProps, 'getPublicHolidayByIDData.updated_by'), prevState.employeeList))
      nextProps.resetGetPublicHolidayByID()
    }
    if (get(nextProps, 'createPublicHolidayData.createdHoliday')) {
      const access_token = localStorage.getItem('access_token')
      nextProps.showConfirm('createSuccess', get(nextProps, 'createPublicHolidayData.status'), get(nextProps, 'createPublicHolidayData.message'))
      nextProps.getPublicHoliday(access_token)
      nextProps.resetCreatePublicHoliday()
    }
    if (get(nextProps, 'editPublicHolidayData.updatedHoliday')) {
      const access_token = localStorage.getItem('access_token')
      set(tempState, 'description', get(nextProps, 'editPublicHolidayData.updatedHoliday.description'))
      set(tempState, 'date', get(nextProps, 'editPublicHolidayData.updatedHoliday.date'))
      set(tempState, 'is_active', get(nextProps, 'editPublicHolidayData.updatedHoliday.is_active'))
      set(tempState, 'updated', get(nextProps, 'getPublicHolidayByIDData.updated'))
      set(tempState, 'updated_by', checkModifiedBy(get(nextProps, 'getPublicHolidayByIDData.updated_by'), prevState.employeeList))
      set(tempState, 'isEdit', false)
      nextProps.showConfirm('editSuccess', get(nextProps, 'editPublicHolidayData.status'), get(nextProps, 'editPublicHolidayData.message'))
      nextProps.getPublicHolidayByID(prevState.holidayID, access_token)
      nextProps.getPublicHoliday(access_token)
      nextProps.resetEditPublicHoliday()
    }
    if (get(nextProps, 'deletePublicHolidayData.deletedHoliday')) {
      const access_token = localStorage.getItem('access_token')
      nextProps.showConfirm('deleteSuccess', get(nextProps, 'deletePublicHolidayData.status'), get(nextProps, 'deletePublicHolidayData.message'))
      nextProps.getPublicHoliday(access_token)
      nextProps.resetDeletePublicHoliday()
    }
    if (nextProps.getEmployeeData !== prevState.employeeList) {
      set(tempState, 'employeeList', nextProps.getEmployeeData)
    }
    if (nextProps.exportPublicHolidayData) {
      window.open(nextProps.exportPublicHolidayData, 'blank')
      nextProps.resetExportPublicHoliday()
    }
    return tempState
  }
  constructor(props) {
    super(props)
    this.state = {
      rowID: '',
      isSpan: false,
      isEdit: false,
      holidayID: '',
      defaultPublicHoliday: [],
      publicHoliday: [],
      holiday: null,
      description: '',
      date: '',
      updated: '',
      updated_by: '',
      is_active: true,
      employeeList: [],
      search: '',
      sort_by: 'date',
      sort_order: 'desc',
    }
    this.handleClickRow = this.handleClickRow.bind(this)
    this.handleClickEdit = this.handleClickEdit.bind(this)
    this.handleInput = this.handleInput.bind(this)
    this.handleDiscard = this.handleDiscard.bind(this)
    this.showForm = this.showForm.bind(this)
    this.cancelForm = this.cancelForm.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.showDiscard = this.showDiscard.bind(this)
    this.cancelDiscard = this.cancelDiscard.bind(this)
    this.showDelete = this.showDelete.bind(this)
    this.cancelDelete = this.cancelDelete.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.handleClickSearch = this.handleClickSearch.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.sortBy = this.sortBy.bind(this)
  }
  componentDidMount() {
    const access_token = localStorage.getItem('access_token')
    this.props.getAuth(access_token)
    this.props.getPublicHoliday(access_token)
    this.props.getEmployee(access_token)
  }
  handleInput(e) {
    this.setState({ [e.target.name]: e.target.value })
  }
  handleClickEdit() {
    this.setState({ isEdit: !this.state.isEdit })
  }
  handleClickRow(span, id, editID) {
    this.setState({
      isSpan: span,
      holidayID: id,
      rowID: editID,
      isEdit: false,
    })
    if (span) {
      const access_token = localStorage.getItem('access_token')
      this.props.getPublicHolidayByID(id, access_token)
    }
  }
  handleClickSearch() {
    this.setState({
      publicHoliday: get(this.state, 'defaultPublicHoliday').filter(searchPublicHoliday, this.state.search),
    })
  }
  handleSearch(e) {
    if (e.keyCode === 13) this.handleClickSearch()
    else if (e.target.value === '') this.setState({ publicHoliday: get(this.state, 'defaultPublicHoliday'), search: '' })
    else this.setState({ search: e.target.value })
  }
  showForm() {
    this.setState({
      date: '',
      description: '',
      is_active: true,
      isEdit: false,
      isSpan: false,
      holidayID: '',
      rowID: '',
    })
    this.props.showModal('holidayForm')
  }
  cancelForm() {
    this.props.hideModal('holidayForm')
  }
  showDelete() {
    this.props.showConfirm('confirmDelete', 'Delete Comfirmation', 'Are you sure to delete ?')
  }
  cancelDelete() {
    this.props.hideConfirm('confirmDelete')
  }
  handleDelete() {
    const access_token = localStorage.getItem('access_token')
    this.props.deletePublicHoliday(this.state.holidayID, access_token)
    this.handleClickRow(false, '', '')
    this.cancelDelete()
  }
  showDiscard() {
    if (this.state.isEdit) {
      this.props.showConfirm('confirmDiscard', 'Discard Changes', 'Are you sure you want to discard all changes ?')
    } else this.handleClickRow(false, '', '')
  }
  cancelDiscard() {
    this.props.hideConfirm('confirmDiscard')
  }
  handleDiscard() {
    this.cancelDiscard()
    this.handleClickRow(false, '', '')
  }
  submitForm() {
    const payload = {
      date: this.state.date === '' ? '' : moment(this.state.date),
      description: this.state.description,
      is_active: this.state.is_active,
    }
    const access_token = localStorage.getItem('access_token')
    if (this.state.isEdit) this.props.editPublicHoliday(this.state.holidayID, payload, access_token)
    else this.props.createPublicHoliday(payload, access_token)
    this.cancelForm()
  }
  sortBy(type, order) {
    this.setState({ sort_by: type, sort_order: order ? 'asc' : 'desc' })
  }
  sortHoliday(data) {
    if (this.state.sort_by === 'date') return orderBy(data, ['date'], [this.state.sort_order])
    else if (this.state.sort_by === 'description') return orderBy(data, ['description'], [this.state.sort_order])
  }
  render() {
    const IsAdminUser = get(this.props, 'authData.user.is_hr_admin_role')
    const IsSystemUser = get(this.props, 'authData.user.is_system_admin')
    const IsHRConfidentialUser = get(this.props, 'authData.user.is_hr_admin_confidential_role')
    const IsManagementUser = get(this.props, 'authData.user.is_management_role')

    const isAuthenticated = get(this.props, 'redirectAuth.isAuthenticated')
    || get(this.props, 'redirectPublicHoliday.isAuthenticated')
    const redirect = get(this.props, 'redirectAuth.redirect')
      || get(this.props, 'redirectPublicHoliday.redirect')
    if (redirect) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      window.location = '/'
    }

    if (IsHRConfidentialUser !== undefined &&
      IsSystemUser !== undefined &&
      IsAdminUser !== undefined &&
      IsManagementUser !== undefined &&
      !(IsHRConfidentialUser || IsSystemUser || IsAdminUser || IsManagementUser)) window.location = '/home'
 
    const button = (
      <div>
        <NewButton outline color="danger" onClick={ () => this.showDelete('confirmDelete') }>Delete</NewButton>
        <NewButton color="success" onClick={ this.state.isEdit ? this.submitForm : this.handleClickEdit }>{ this.state.isEdit ? 'Save' : 'Edit' }</NewButton>
      </div>
    )
    const buttonOK = (type) => (
      <div>
        <NewButton color="success" onClick={ () => this.props.hideConfirm(type) }>OK</NewButton>
      </div>
    )
    const buttonCreate = (
      <div>
        <NewButton color="success" onClick={ this.submitForm }>Create</NewButton>
      </div>
    )
    const buttonDiscard = (
      <div>
        <NewButton color="" onClick={ this.cancelDiscard }>Cancel</NewButton>
        <NewButton color="danger" onClick={ this.handleDiscard }>Discard</NewButton>
      </div>
    )
    const buttonDelete = (
      <div>
        <NewButton color="" onClick={ this.cancelDelete }>Cancel</NewButton>
        <NewButton color="danger" onClick={ this.handleDelete }>Delete</NewButton>
      </div>
    )
    const isFetching = get(this.props, 'getIsFetchingHoliday')
    || get(this.props, 'getIsFetchingEmployee')
    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper fluid>
        <Searchbar
          toggleCreate={ this.showForm }
          // export={ () => this.props.exportPublicHoliday(localStorage.getItem('access_token')) }
          handleSearch={ this.handleSearch }
          handleClickSearch={ this.handleClickSearch }
          search={ this.state.search }
        />
        { isFetching &&
          <Overlay>
            <OverlayWrapper>
              <BeatLoader
                css={ css(`
                  position: absolute;
                  left: 50%;
                  top: 50%;
                `) }
                sizeUnit={ "px" }
                size={ 15 }
                color={ '#D44B49' }
                loading={ isFetching }
              />
            </OverlayWrapper>
          </Overlay>
        }
        <Row noGutters>
          {
            get(this.props, 'confirmType') === 'createSuccess' &&
            <CustomModalMessage
              hide={ () => this.props.hideConfirm('createSuccess') }
              show={ get(this.props, 'confirmType') === 'createSuccess' }
              type={ get(this.props, 'confirmStatus') }
              message={ get(this.props, 'confirmMessage') }
              button={ buttonOK('createSuccess') }
            />
          }
          {
            get(this.props, 'confirmType') === 'editSuccess' &&
            <CustomModalMessage
              hide={ () => this.props.hideConfirm('editSuccess') }
              show={ get(this.props, 'confirmType') === 'editSuccess' }
              type={ get(this.props, 'confirmStatus') }
              message={ get(this.props, 'confirmMessage') }
              button={ buttonOK('editSuccess') }
            />
          }
          {
            get(this.props, 'confirmType') === 'deleteSuccess' &&
            <CustomModalMessage
              hide={ () => this.props.hideConfirm('deleteSuccess') }
              show={ get(this.props, 'confirmType') === 'deleteSuccess' }
              type={ get(this.props, 'confirmStatus') }
              message={ get(this.props, 'confirmMessage') }
              button={ buttonOK('deleteSuccess') }
            />
          }
          { get(this.props, 'confirmType') === 'confirmDiscard' &&
          <CustomModalMessage
            hide={ this.cancelDiscard }
            show={ get(this.props, 'confirmType') === 'confirmDiscard' }
            type={ get(this.props, 'confirmStatus') }
            message={ get(this.props, 'confirmMessage') }
            button={ buttonDiscard }
          />
          }
          { get(this.props, 'confirmType') === 'confirmDelete' &&
          <CustomModalMessage
            hide={ this.cancelDelete }
            show={ get(this.props, 'confirmType') === 'confirmDelete' }
            type={ get(this.props, 'confirmStatus') }
            message={ get(this.props, 'confirmMessage') }
            button={ buttonDelete }
          />
          }
          <Row noGutters>
            <Col>
              <PublicHolidayTable
                handleInput={ this.handleInput }
                handleClickRow={ this.handleClickRow }
                sortBy={ this.sortBy }
                holidays={ this.sortHoliday(this.state.publicHoliday) }
                { ...this.state }
              />
            </Col>
            {
              this.state.isSpan &&
              <Col>
                <PublicHolidayForm
                  handleInput={ this.handleInput }
                  button={ button }
                  { ...this.state }
                  handleClickRow={ this.handleClickRow }
                  cancelForm={ this.cancelForm }
                  showDelete={ this.showDelete }
                  cancelDelete={ this.cancelDelete }
                  showDiscard={ this.showDiscard }
                  cancelDiscard={ this.cancelDiscard }
                />
              </Col>
            }
          </Row>
          {
            <Modal isOpen={ get(this.props, 'modalType') === 'holidayForm' } toggle={ this.cancelForm }>
              <PublicHolidayForm
                create={ true }
                button={ buttonCreate }
                { ...this.state }
                handleInput={ this.handleInput }
                cancelForm={ this.cancelForm }
              />
            </Modal>
          }
        </Row>
      </Wrapper>
    )
  }
}

HolidayMasterPage.propTypes = {
  getAuth: PropTypes.func.isRequired,
  getPublicHoliday: PropTypes.func.isRequired,
  getEmployee: PropTypes.func.isRequired,
  getPublicHolidayByID: PropTypes.func.isRequired,
  editPublicHoliday: PropTypes.func.isRequired,
  createPublicHoliday: PropTypes.func.isRequired,
  deletePublicHoliday: PropTypes.func.isRequired,
  exportPublicHoliday: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  showConfirm: PropTypes.func.isRequired,
  hideConfirm: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  modalStatus: modalSelector.modalStatus,
  modalType: modalSelector.modalType,
  modalMessage: modalSelector.modalMessage,
  confirmStatus: modalSelector.confirmStatus,
  confirmType: modalSelector.confirmType,
  confirmMessage: modalSelector.confirmMessage,
  authData: authSelector.getAuth,
  redirectAuth: authSelector.redirectAuth,
  redirectPublicHoliday: publicHolidaySelector.redirectPublicHoliday,
  getIsFetchingHoliday: publicHolidaySelector.getIsFetching,
  getIsFetchingEmployee: employeeSelector.getIsFetching,
  getPublicHolidayData: publicHolidaySelector.getPublicHolidayData,
  getPublicHolidayByIDData: publicHolidaySelector.getPublicHolidayByIDData,
  editPublicHolidayData: publicHolidaySelector.editPublicHolidayData,
  createPublicHolidayData: publicHolidaySelector.createPublicHolidayData,
  deletePublicHolidayData: publicHolidaySelector.deletePublicHolidayData,
  exportPublicHolidayData: publicHolidaySelector.getExportURL,
  getEmployeeData: employeeSelector.getListUser,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  showModal: modalAction.showModal,
  hideModal: modalAction.hideModal,
  showConfirm: modalAction.showConfirm,
  hideConfirm: modalAction.hideConfirm,
  getAuth: authAction.auth,
  resetAuth: authAction.resetAuthUser,
  getPublicHoliday: publicHolidayAction.getPublicHoliday,
  resetGetPublicHoliday: publicHolidayAction.resetGetPublicHoliday,
  getPublicHolidayByID: publicHolidayAction.getPublicHolidayByID,
  resetGetPublicHolidayByID: publicHolidayAction.resetGetPublicHolidayByID,
  editPublicHoliday: publicHolidayAction.editPublicHoliday,
  resetEditPublicHoliday: publicHolidayAction.resetEditPublicHoliday,
  createPublicHoliday: publicHolidayAction.createPublicHoliday,
  resetCreatePublicHoliday: publicHolidayAction.resetCreatePublicHoliday,
  deletePublicHoliday: publicHolidayAction.deletePublicHoliday,
  resetDeletePublicHoliday: publicHolidayAction.resetDeletePublicHoliday,
  exportPublicHoliday: publicHolidayAction.exportPublicHoliday,
  resetExportPublicHoliday: publicHolidayAction.resetExportPublicHoliday,
  getEmployee: employeeAction.getUser,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withLayout(HolidayMasterPage))

const Wrapper = styled(Container)`
  padding: 0px;
  background-color: #F1F1F1;
`
const NewButton = styled(Button)`
  width: 150px;
  height: 50px;
  margin: 10px;
`
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`
const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`




// WEBPACK FOOTER //
// ./src/pages/public-holiday/index.js